import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { ToastrService } from 'ngx-toastr';
import { AddVesselDialogComponent } from '../add-vessel-dialog/add-vessel-dialog.component';
import { VesselData } from '../vessel-reg/vessel-data.model';
import { LocalStorageService } from './local-storage.service';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { AddSpeciesDialogComponent } from '../add-species-dialog/add-species-dialog.component';
import { LookupItem } from './lookup-item.model';
import { OperatorUser } from './operator-user.model';


@Injectable({
  providedIn: 'root'
})
export class CommonFunctionService {

  constructor(
    private dataSync: LocalStorageService,
    private dialog: MatDialog,
     private toastr: ToastrService,
      private onlineStatus: OnlineStatusService,
       private auth: AuthService,
        public router: Router) { }


  
  /*
    Vessel functionality, adding and checking if valid
  */
  addVessel(index: number, isEdit: boolean): Promise<VesselData> {

    return new Promise<VesselData>((res, rej) => {

      const dialogRef = this.dialog.open(AddVesselDialogComponent, {
        width: '425px',
        data: {
          vessel: index != -1 ? this.dataSync.current_user().operatedVessels[index] : null,
          edit: isEdit
        }

      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        if (result) {
          if (result != 'delete') {
            
            let newVessel = new VesselData(result.vesselName, result.vesselNumber);
  
            if (this.onlineStatus.getStatus() === OnlineStatusType.OFFLINE) {
              newVessel.isRecognized = false;
              this.dataSync.current_user.update(user => {
                if (index == -1) user.operatedVessels.push(newVessel);
                else user.operatedVessels[index] = newVessel;
                return user;
              });
              
              this.dataSync.updateUserVessels(this.dataSync.current_user().userName, this.dataSync.current_user().operatedVessels);           
              this.toastr.warning('Vessel ' + newVessel + ' cannot be verified while offline', 'Unrecognized vessel');
              res(newVessel);
              return;
            }
  
            if (this.auth.checkAccessToken().expired) {
              console.log("Access token expired, refreshing..");
              if (this.auth.checkRefreshToken().expired) {
                //Go to menu screen
                this.toastr.warning('Login to add and view your vessels' ,'Sign-up session expired');
                this.router.navigate(['menu']);
                rej('Refresh token expired');
              } else {
                this.auth.postRefreshToken().subscribe((token: any) => {
                  let user = this.dataSync.current_user();
                  user.accessToken = token.accessToken;
                  user.refreshToken = token.refreshToken;
                  this.dataSync.current_user.set(user);
                  this.dataSync.updateUser(false, true).then(() => {
                    this.postVesselSearch(result.vesselNumber, newVessel, index);
                    res(newVessel);
                    return;
                  });
                  this.dataSync.accessToken.set(token.accessToken);
                  this.dataSync.refreshToken.set(token.refreshToken);
                })                         
              }
            } else {
              //Post updated vessel search instead of vessel search
              this.postVesselSearch(result.vesselNumber, newVessel, index);
              res(newVessel); 
              return;            
            }          
          } else if (index != -1) {
            let vesselName = this.dataSync.current_user().operatedVessels[index]; //.splice(index, 1)[0];
            if (this.dataSync.user_trip().groundfishDelivery.vessel.vesselName == vesselName.vesselName) {
              this.dataSync.user_trip.update(trip => {
                trip.groundfishDelivery.vessel = new VesselData('', '');
                return trip;
              });
            }
            this.dataSync.updateUser(true, false).then(() => {
              this.toastr.success('Vessel list updated', 'Success');
            });
          }
        }     
      });
    })
  }

  /**
   * Valid vessel?
   * @param vesselNum 
   * @param newVessel 
   */
  postVesselSearch(vesselNum: any, newVessel: VesselData, index: number) {
    if (index != -1) this.dataSync.current_user.update(user => {
      user.operatedVessels[index] = newVessel;
      return user;
    });
console.log('update user for vessel add')
    this.auth.postVesselSearch(vesselNum).subscribe((list: any[]) => {
      this.dataSync.current_user.update(user => {
        if (index != -1) user.operatedVessels[index].isRecognized = list.length > 0;
        else {
          newVessel.isRecognized = (list.length > 0);
          user.operatedVessels.push(newVessel);
        } 
        return user;
      });


      this.dataSync.updateUserVessels(this.dataSync.current_user().userName, this.dataSync.current_user().operatedVessels);
      if (list.length > 0) this.toastr.success('Recognized vessel added.', 'Success');
      else this.toastr.warning('Vessel ' + newVessel + ' is not recognized by its number. Review for typos', 'Unrecognized vessel');
    }, _ => {
      this.dataSync.current_user.update(user => {
        if (index != -1) user.operatedVessels[index].isRecognized = false;
        else {
          newVessel.isRecognized = false;
          user.operatedVessels.push(newVessel);
        } 
        return user;
      });

      this.dataSync.updateUserVessels(this.dataSync.current_user().userName, this.dataSync.current_user().operatedVessels)
    })
  }


  addSpecies(index: number, filterOption: 'Combined' | 'HMS' | 'Groundfish' | 'Trawl'): Promise<boolean> {

    return new Promise<boolean>((res, rej) => {
      this.dialog.open(AddSpeciesDialogComponent, {
        width: '425px',
        data: {
          species: index === -1 ? null : this.dataSync.current_user().favoriteSpecies[index],
          filterOption: filterOption
        }
      }).afterClosed().subscribe((result: any) => {
  
        console.log(result);
  
        if (result) {
  
          // if species added successfully (deleting a new species does nothing)
          if (result != 'delete') {
            if (this.onlineStatus.getStatus() === OnlineStatusType.OFFLINE) {
              this.updateSpecies(result.species, index);       
              this.toastr.success('Species ' + result.species.name + ' has been added offline.', 'Offline');
              res(true);
              return;
            }
  
            if (this.auth.checkAccessToken().expired) {
              console.log("Access token expired, refreshing...");
  
              if (this.auth.checkRefreshToken().expired) {
                // Go to menu screen
                this.toastr.warning('Login to add and view your favorite species.', 'Sign-up session expired');
                this.router.navigate(['menu']);
                res(false);
                return;
              } else {
                this.auth.postRefreshToken().subscribe((token: any) => {
                  let user = this.dataSync.current_user();
                  user.accessToken = token.accessToken;
                  user.refreshToken = token.refreshToken;
                  this.dataSync.current_user.set(user);
                  this.dataSync.updateUser(false, true).then(() => {
                    this.updateSpecies(result.species, index);
                    this.toastr.success("Species " + result.species.name + " added.", "Add Success");
                    res(true);
                    return;
                  });
                });
              }
            } else {
              this.updateSpecies(result.species, index);
              this.toastr.success("Species " + result.species.name + " added.", "Add Success");
              res(true);
            }
          } else if (index != -1) {
            this.dataSync.current_user.update(user => {user.favoriteSpecies.splice(index, 1); return user});
            this.dataSync.updateUserSpecies(this.dataSync.current_user().favoriteSpecies).then(() => {
              res(true);
              return;
            });
          } else {
            res(false);
            return;
          }
        } else {
          res(false);
        }
      });
    })   
  }



  updateSpecies(species: LookupItem, editIndex: number) {
    this.dataSync.current_user.update(user => {
      let next = OperatorUser.transformAnonymous(user);     
      if (editIndex != -1) next.favoriteSpecies[editIndex] = species;
      else next.favoriteSpecies.push(species);
      return next;
    })  
   this.dataSync.updateUserSpecies(this.dataSync.current_user().favoriteSpecies);
  }

}
